<template>
  <div class="animated fadeIn">
    <div class="container-fluid">
      <div class="row">
        <div v-if="dashdata" class="col-sm" style="margin-top: -1em;">
          <ResultTable
            :dashdata="dashdata"
            :isCluster="isCluster"
            :thresholds="thresholds"
            :percentageNumberOfDecimalPoints="percentageNumberOfDecimalPoints"
            :activeCompareLabel="activeCompareLabel"
            :componentId="componentKey" />
        </div>
        <div v-if="!dashdata">
          {{ $t('Webportal.NoDataFound')}}
        </div>
      </div>
      <div class="row">
        <div class="col-sm">
          <!-- <Legend></Legend> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';
  import AppConfig from '@/mixins/AppConfig-APP_TARGET';
  import EventBus from '@/services/EventBus.js'
  import DashboardService from '@/services/DashboardService';
  import ResultTable from './ResultTable.vue';

  export default {
    name: 'DashboardPanel',

    mixins: [ AppConfig ],

    components:{
      ResultTable
    },

    props: {
      isCluster: {default: true},
      isCompareMode: {default: false},
      thresholds: null,
      percentageNumberOfDecimalPoints: {type: Number, default: 2},
      componentKey: {type: Number, default: 0},
      //groupmodeIndexIndicator: {type: Number, default: -1},
      filtervalues: null,
      selection: null
    },

    watch: {
      selection: {
        handler(newVal, oldVal) {
          if (this.checkFilterChanged(newVal, oldVal)) {
            // console.log('DashboardPanel - watch - selection');
            this.getDashboard();
          }
        },
      },

      isCluster: {
        handler(newVal, oldVal) {
          this.onKpiSwitchChanged();
        },
      },
    },

    created() {
      if (!this.dashdata) {
        // console.log('DashboardPanel - created');
        this.getDashboard();
      }
      EventBus.$on('LocalizationChanged', this.localizationChanged);
    },

    mounted() {
      // console.log('DashboardPanel - mounted');
    },

    beforeUnmount() {
      EventBus.$off('LocalizationChanged', this.localizationChanged);
    },

    data() {
      return {
        dashdata: null,
        isLoading: false,
        cockpitCancelToken: null,
        activeCompareLabel: 'N/A',
      }
    },

    methods: {
      localizationChanged(localizationId) {
        this.getDashboard();
      },

      // KpiSwitch
      // *********
      onKpiSwitchChanged() {
        if (!this.dashdata) return;

        // console.log('DashboardPanel - onKpiSwitchChanged - compareModeActive: ' + this.isCompareMode);
        if (this.isCompareMode) {
          const groupElements = this.getGroupListForCompareMode(true);
          // console.log('DashboardPanel - onKpiSwitchChanged - groupElements: ');
          // console.log(this.selection);
          // console.log(groupElements);
          this.dashdata = this.initDashdata([...this.dashdata.data], groupElements);
        } else {
          this.dashdata = this.initDashdata([...this.dashdata.data]);
        }
      },

      getGroupmodeIndexIndicator() {

        let indexIndicator = undefined;
        // console.log('DashboardPanel - getGroupmodeIndexIndicator');
        // console.log(this.filtervalues);
        // console.log(this.selection.customProperties);

        // check if locations are selected
        if (this.selection && this.selection.locations && this.selection.locations.length > 0) {
          indexIndicator = -1;
        } else if (this.selection && this.selection.customProperties && this.filtervalues.customProperties){

          const propKey = Number(this.selection.customProperties.substring(0, this.selection.customProperties.indexOf('^')));
          // console.log('Property key: ' + propKey);

          // check which custom properties are selected
          for (let i=0; i < this.filtervalues.customProperties.length; i++) {
            if (this.filtervalues.customProperties[i].id === propKey) {
              indexIndicator = i;
              break;
            }
          }
        }

        // console.log('DashboardPanel - getGroupmodeIndexIndicator - index: ' + indexIndicator);
        return indexIndicator;
      },

      getDashboard() {
        //console.log('DashboardPanel - getDashboard');
        //console.log('DashboardPanel - getDashboard - isCompareMode: ' + this.isCompareMode);

        // Cancel previous request
        const token = this.initCancelToken(this.cockpitCancelToken);

        this.isLoading = true;

        // console.log('DashboardPanel - getDashboard - filter: ' + JSON.stringify(this.selection));
        if (this.selection && this.selection.surveys) {

          // decide whether in compare mode or not
          if (!this.isCompareMode) {
            this.dashdata = null;
            // read dashboarddata with one backend call
            DashboardService.getDashboard(this.selection, token)
              .then(response => {
                this.dashdata = this.initDashdata([response.data]);;
                this.isLoading = false;
              })
              .catch(error => {
                console.warn('Error to receive dashboard data: ' + error);
                this.isLoading = false;
              });
          } else {

            // we make many backend calls parallel for each group result
            let indexIndicator = this.getGroupmodeIndexIndicator();
            let backendCalls = [];
            let groupElements = this.getGroupListForCompareMode(false);

            // add overall backend call (without group filter option) first
            let overallFilter = Object.assign({}, this.selection);
            backendCalls.push(DashboardService.getDashboard(overallFilter, token));

            // console.log(groupElements);

            // and now for each selected options
            for (let group of groupElements) {
              let filter = Object.assign({}, this.selection);;

              // console.log('Backend call for: ' + group.label);

              if (indexIndicator === -1) {
                // locations
                filter.locations = group.id;
              } else {
                // custom properties
                filter.customProperties = group.id;
              }

              backendCalls.push(DashboardService.getDashboard(filter, token));
            }

            // add overall to the grouplist (after foreach backend call)
            groupElements.unshift({id: 'Overall', label: 'Overall'});

            //console.log("FilterValuesBefore: " + JSON.stringify(this.filtervalues));

            // get all calls together
            Promise.all(backendCalls)
              .then(response => {
                this.isLoading = false;
                //console.log("FilterValuesAfterPromise: " + JSON.stringify(this.filtervalues));
                this.dashdata = this.initDashdata(response.map(obj => obj.data), groupElements);
              })
              .catch (error => {
                console.warn('Error to receive dashboard data: ' + error);
                this.isLoading = false;
              });
          }
        } else {
          this.dashdata = null;
          this.isLoading = false;
        }
      },

      initDashdata(dash, groupList = [{id: 'default', label: 'default'}]) {
        // console.log('DashboardPanel - initDashdata');
        if (!dash || !_.some(dash, d => !_.isEmpty(d)))
          return null;

        let retVal = {
          data: dash,
          isGroupMode: this.isCompareMode,
          list: []
        };

        const hiddenResultKpiGroups = this.hiddenResultKpiGroups();
        if (hiddenResultKpiGroups.length > 0)
          dash.forEach(d =>
            d.KPIGroup?.filter(kg => hiddenResultKpiGroups.includes(kg.Code))
              .forEach(kg => kg.SurveyWave?.forEach(sw => {
                delete sw.PointsMax;
                delete sw.PointsReached;
                delete sw.Result;
              }))
          );

        // if in group mode then the Overall results should not be in the data list (e.g. Grid data)
        // but overall data is needed at other places
        let startIndex = 0;
        if (this.isCompareMode && groupList.length > 1) {
          startIndex = 1;
        }

        for (let i=startIndex; i<groupList.length; i++) {

          if (!this.isCluster) {

            if (_.isEmpty(dash[i].KPI)) {
                continue;
            }

            // KPI
            dash[i].KPI.forEach(kpi => {
                let item = {
                    Code: kpi.Code,
                    GroupCode: kpi.GroupCode,
                    Name: kpi.Name,
                    SurveyWave: kpi.SurveyWave,
                    RootParent: dash[0].KPIGroup?.find(obj => obj.Code === kpi.GroupCode),
                    Parent: dash[i].KPIGroup?.find(obj => obj.Code === kpi.GroupCode),
                    CompareGroup: (groupList[i].label.length>0) ? groupList[i].id + '^' + groupList[i].label : groupList[i].id,
                    DataSource: dash[i]
                };

                retVal.list.push(item);
            });

          } else {

            if (_.isEmpty(dash[i].Question)) {
                continue;
            }

            // Questions
            if (!_.isEmpty(dash[i].Question)) {
                dash[i].Question.forEach(q => {

                  let item = {
                      Code: q.Code,
                      Name: q.QuestionText,
                      SurveyWave: q.SurveyWave,
                      RootParent: dash[0].Cluster?.find(obj => obj.Code === q.Code),
                      Parent: dash[i].Cluster?.find(obj => obj.Code === q.Code),
                      CompareGroup: (groupList[i].label.length>0) ? groupList[i].id + '^' + groupList[i].label : groupList[i].id,
                      DataSource: dash[i]
                  };

                  retVal.list.push(item);
                });
            }
          }
        }

        // refresh active compare label
        const indexIndicator = this.getGroupmodeIndexIndicator();

        if (indexIndicator === -1 && this.filtervalues && this.filtervalues.locations) {
          this.activeCompareLabel = this.$t('Webportal.LocationFilter.Placeholder').replace('…', '').replace('...', '');
        } else if (indexIndicator != undefined && this.filtervalues && this.filtervalues.customProperties && this.filtervalues.customProperties.length > indexIndicator) {
          this.activeCompareLabel = this.filtervalues.customProperties[indexIndicator].label;
        } else {
          this.activeCompareLabel = 'N/A';
        }
        // console.log('DashboardPanel - activeCompareLabel: ' + this.activeCompareLabel);

        // console.log(retVal);
        return retVal;
      },

      calculateDelta(act, prev) {
          if (!act || !prev) { return 0; }
          if (!act.Result || !prev.Result) { return 0; }
          return act.Result - prev.Result;
      },

      initCancelToken(token) {
        // console.log('DashboardPanel - initCancelToken');

        // Cancel previous request
        if (token)
          token.cancel();
        return axios.CancelToken.source();
      },

      checkFilterChanged(newVal, oldVal) {
        // console.log('DashboardPanel - checkFilterChanged');

        let retVal = false;

        // if no last filter selection available treat it like a filter change
        if (!oldVal) {
          return true;
        }

        // check each filter selection
        const currentFilterSelection = newVal;

        retVal = currentFilterSelection.client !== oldVal.client;
        retVal = retVal | currentFilterSelection.projects !== oldVal.projects;
        retVal = retVal | currentFilterSelection.surveys !== oldVal.surveys;
        retVal = retVal | currentFilterSelection.waves !== oldVal.waves;
        retVal = retVal | currentFilterSelection.scenarios !== oldVal.scenarios;
        retVal = retVal | currentFilterSelection.dateFrom?.getTime() !== oldVal.dateFrom?.getTime() ||
          currentFilterSelection.dateTo?.getTime() !== oldVal.dateTo?.getTime();
        retVal = retVal | currentFilterSelection.locations !== oldVal.locations;
        retVal = retVal | currentFilterSelection.customProperties !== oldVal.customProperties;

        return retVal;
      },

      getGroupListForCompareMode(withOverallGroup = false) {

        let indexIndicator = this.getGroupmodeIndexIndicator();
        let retVal = [];

        //console.log('DashboardPanel - getGroupListForCompareMode - indexIndicator: ' + indexIndicator);

        if (withOverallGroup) {
            retVal.push({id: 'Overall', label: 'Overall'});
        }

        if (indexIndicator != undefined) {
          // iterate through selected options and prepare the parallel calls
          if (indexIndicator === -1) {
            if (this.selection && this.selection.locations && this.selection.locations.length > 0) {
              let locationIds = this.selection.locations.split(',');
              for (let id of locationIds) {
                const item = this.filtervalues.locations.find(obj => obj.id === Number(id));
                if (item) {
                  retVal.push({id: item.id, label: item.label});
                }
              }
            }
          } else {
            if (this.selection && this.selection.customProperties) {
              const custPropArray = this.selection.customProperties.split('|');
              // console.log('Selected custom properties: ');
              // console.log(custPropArray);
              // console.log('DashboardPanel - getGroupListForCompareMode - filtervalues.customProperties[indexIndicator]: ');
              // console.log(this.filtervalues.customProperties[indexIndicator]);

              for (let id of custPropArray)
              {
                if (this.filtervalues.customProperties[indexIndicator]
                  && this.filtervalues.customProperties[indexIndicator].children
                  && this.filtervalues.customProperties[indexIndicator].children.length > 0) {
                    const item = this.filtervalues.customProperties[indexIndicator].children.find(obj => obj.id === id);
                    if (item) {
                      retVal.push({id: item.id, label: ''});
                    }
                }
              }
            }
          }
        }

        // console.log('DashboardPanel - getGroupListForCompareMode - retVal: ');
        // console.log(retVal);

        return retVal;
      },
    },

    computed: {
    }
  }

</script>

<style>

</style>

<style scoped>

.row {
  padding: 0px;
}

.col-sm {
  padding-top: 1rem;
}

h3{
  height: 36pt;
  line-height: 28pt;
  text-align: center;
  color: #111111;
  font-size: 16pt;
  font-stretch: extra-condensed;
}

div.leftImage {
  position: absolute;
  left: 3px;
  top: 0px;
  bottom: 1px;
}

.pagbox {
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;

  flex-wrap: wrap;

  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;

  -ms-flex-justify-content: flex-start;
  -webkit-justify-content: flex-start;
  justify-content: flex-start;

  width: 100%;
}

.pagheader {
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;

  flex-wrap: wrap;

  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;

  -ms-flex-justify-content: space-between;
  -webkit-justify-content: space-between;
  justify-content: space-between;

  width: 100%;
}

.pagbox>* {
  flex: 1 1 300px;
  -ms-flex: 0 0 300px;
  /* margin:1px;
  margin: .25em; */
}

.pagheader>* {
  flex: 1 1 150px;
  -ms-flex: 0 0 150px;
  margin:1px;
  /* margin: .5em; */
}

.pagitem{
  min-width: 800px;
  /* max-width: 1200px; */
  transform-style: flat;
  /* height: 150px; */
  transition: transform .3s; /* Animation */
}

.pagshopsitem{
  min-width: 150px;
  transform-style: flat;
  /* height: 150px; */
  transition: transform .3s; /* Animation */
}

.pagborder {
  background-color: rgba(255, 255, 255, 0.596);

  margin:0.25em;
  border-style: solid;
  border-width: 1px;
  border-color: #BFBFBF;
  border-radius: 4px;
}

</style>
